import { render, staticRenderFns } from "./SettingsListRow.vue?vue&type=template&id=967cd3d4&"
import script from "./SettingsListRow.vue?vue&type=script&lang=ts&"
export * from "./SettingsListRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports